// @flow

import { type Theme } from './types';
import defaultTheme from './default-theme';

const theme: Theme = {
  ...defaultTheme,
  button: {
    ...defaultTheme.button,
    rounded: false,
    fontFamily: 'display',
  },
  colors: {
    ...defaultTheme.colors,
    black: 'hsl(0, 0%, 0%)',
    primary: l => `hsl(29, 71%, ${Math.min(l, 100)}%)`,
    secondary: l => `hsl(29, 71%, ${Math.min(l, 100)}%)`,
    info: l => `hsl(0, 0%, ${l}%)`,
  },
  layout: {
    ...defaultTheme.layout,
    bordered: true,
    raised: false,
  },
};

export default theme;
